export const FAVORITE_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
    <path fill="#FF1F34" d="M0 3.006C0 6.973 5.5 10 5.5 10S11 6.973 11 3.006C11 1.346 9.618 0 7.912 0 6.936 0 6.066.441 5.5 1.13A3.114 3.114 0 003.088 0C1.382 0 0 1.346 0 3.006z"/>
  </svg>
`;

export const OLD_ONLINE_BOOKING_ICON = `
  <svg width="12" height="12" viewBox="0 0 16 16" fill="#0468FF" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0H13V2H13.4C13.9601 2 14.2401 2 14.454 2.10899C14.6422 2.20487 14.7951 2.35785 14.891 2.54601C15 2.75992 15 3.03995 15 3.6V6H13V4.66667H3V13H7V15H2.6C2.03995 15 1.75992 15 1.54601 14.891C1.35785 14.7951 1.20487 14.6422 1.10899 14.454C1 14.2401 1 13.9601 1 13.4V3.6C1 3.03995 1 2.75992 1.10899 2.54601C1.20487 2.35785 1.35785 2.20487 1.54601 2.10899C1.75992 2 2.03995 2 2.6 2H3V0H5V2H11V0ZM8.30285 11.1761L10.2611 6.35797L14.6015 8.12185L10.9817 10.8652L13.1317 11.7389L7.87009 15.5007L9.43978 11.6382L8.30285 11.1761Z" />
  </svg>
`;

export const DISCOUNT_ICON = `
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2Z" fill="#227E01"/>
    <path d="M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z" fill="#227E01"/>
    <path d="M9 0L0.0139197 12H3L11.9859 0H9Z" fill="#227E01"/>
  </svg>
`;

// Шевроны пагинации мультипина — path из @cian/ui-kit-design-tokens (ActionChevronLeftSmall / RightSmall, 16px),
// цвет наследуется от кнопки через currentColor
export const CHEVRON_LEFT_SMALL_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m9.646 12.707 1.414-1.414L7.768 8l3.292-3.293-1.414-1.414L4.94 8z"/>
  </svg>
`;

export const CHEVRON_RIGHT_SMALL_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m6.354 12.707-1.415-1.414L8.232 8 4.94 4.707l1.415-1.414L11.06 8z"/>
  </svg>
`;
